import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import validator from 'validator';

import MuiTextField from '@material-ui/core/TextField';
import MuiButton from '@material-ui/core/Button';
import MuiDialog from '@material-ui/core/Dialog';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiSelect from '@material-ui/core/Select';
import MuiMenuItem from '@material-ui/core/MenuItem';
import MuiFormControl from '@material-ui/core/FormControl';
import MuiInputLabel from '@material-ui/core/InputLabel';

import { useMutation } from 'react-query';

import * as API from 'api';
const Groups = API.Groups();

const styles = theme => ({
  formRow: {
    display: 'flex',
    alignItems: 'flex-end',
    marginBottom: '10px',
  },
  select: {
    marginBottom: '4px',
    minWidth: '100px',
    width: '50%',
  },
  dialogFooter: {
    padding: theme.spacing(1.5),
  },
});

const DialogCreatePayee = ({ open, onClose, onCreated, groups, classes, groupId }) => {
  const [form, setForm] = useState({});
  const [formErrors, setFormErrors] = useState([]);

  const { mutate, isLoading } = useMutation(
    ({ groupId: id, email, name }) => Groups.createPayeeIndividual(id, email, name),
    {
      onSuccess: () => {
        handleClose();
      },
      onError: err => alert(err?.data?.detail),
    }
  );

  const handleFormSubmit = evt => {
    evt.preventDefault();
    mutate(form);
  };

  function updateForm({ target: { value, name } }) {
    setForm({ ...form, [name]: value });
    if (name === 'groupId') return;
    const isValid = name === 'email' ? validator.isEmail(value) : !validator.isEmpty(value);
    setFormErrors([...formErrors.filter(e => e !== name), !isValid ? name : null].filter(e => e));
  }

  function handleClose() {
    setForm({});
    if (groupId) onCreated();
    onClose();
  }

  return (
    <MuiDialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
      <MuiDialogTitle id="form-dialog-title">Create New Payee</MuiDialogTitle>
      <form onSubmit={handleFormSubmit}>
        <MuiDialogContent>
          <div className={classes.formRow}>
            <MuiFormControl className={classes.select}>
              <MuiInputLabel>Group</MuiInputLabel>
              <MuiSelect name="groupId" value={form.groupId || ''} onChange={updateForm}>
                {groups &&
                  groups.map((group, i) => (
                    <MuiMenuItem key={i} value={group.id}>
                      {group.name}
                    </MuiMenuItem>
                  ))}
              </MuiSelect>
            </MuiFormControl>
          </div>
          <div className={classes.formRow}>
            <MuiTextField
              autoFocus
              margin="dense"
              name="name"
              label="Full Name"
              type="text"
              value={form.name || ''}
              onChange={updateForm}
            />
            <MuiTextField
              margin="dense"
              name="email"
              label="Email Address"
              type="email"
              value={form.email || ''}
              onChange={updateForm}
            />
          </div>
        </MuiDialogContent>
        <MuiDialogActions className={classes.dialogFooter}>
          <MuiButton variant="contained" onClick={handleClose} disabled={isLoading}>
            Cancel
          </MuiButton>
          <MuiButton
            variant="contained"
            color="primary"
            type="submit"
            disabled={!!formErrors.length || !form.groupId || isLoading}>
            Create
          </MuiButton>
        </MuiDialogActions>
      </form>
    </MuiDialog>
  );
};

export default withStyles(styles)(DialogCreatePayee);
